import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { EventsQueueState } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: EventsQueueState = getDefaultState();

const namespaced: boolean = true;

export const eventqueue: Module<EventsQueueState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
